// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"RolesTable_spinnerContainer__dLfQi","botonAdd":"RolesTable_botonAdd__RFxI4"};